import React from "react";

export function FoodForkSpoonIcon({ vectorEffect, ...rest }: React.ComponentProps<"svg">) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="food-kitchenware-spoon-plate--fork-plate-food-dine-cook-utensils-eat-restaurant-dining--Streamline-Core">
        <g id="Group">
          <path
            id="Vector"
            d="M1 1V5.5C1 6.82608 1.52678 8.09785 2.46447 9.03553C3.40215 9.97322 4.67392 10.5 6 10.5C7.32608 10.5 8.59785 9.97322 9.53553 9.03553C10.4732 8.09785 11 6.82608 11 5.5V1"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
          <path
            id="Vector_2"
            d="M6 1V27"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
          <path
            id="Vector_3"
            d="M27 27C23.5522 27 20.2456 25.6304 17.8076 23.1924C15.3696 20.7544 14 17.4478 14 14C14 10.5522 15.3696 7.24558 17.8076 4.80761C20.2456 2.36964 23.5522 1 27 1"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
          <path
            id="Vector_4"
            d="M27 21C25.1435 21 23.363 20.2625 22.0503 18.9497C20.7375 17.637 20 15.8565 20 14C20 12.1435 20.7375 10.363 22.0503 9.05025C23.363 7.7375 25.1435 7 27 7"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
        </g>
      </g>
    </svg>
  );
}
